<template>
  <div class="full-area">
    <header class="question-header image-question contain-image" v-if="data.fields.questionImage.fields.file.url">
      <div
        class="img"
        :style="{'backgroundImage': `url(${data.fields.questionImage.fields.file.url})`}"
      ></div>
    </header>
    <h2
      class="optional-question-title"
      v-if="data.fields.questionTitle"
    >{{data.fields.questionTitle}}</h2>

    <content class="content delay-entry">
      <el-rate
        class="enlarge-icon"
        v-model="rating"
        :colors="colors">
      </el-rate>
    </content>
    <footer>
      <SkipQuestionButton
        :location="'locate-bottom'"
        v-on:skip="selectThis('NS/NR')"
      ></SkipQuestionButton>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Rating',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      rating: 0,
      form: {
        question: this.data.fields.questionTitle,
        id: this.data.sys.id,
        selected: [],
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      },
      colors: [ '#f56c6c', '#BFA28E', '#88D8B0' ]
    }
  },

  methods: {
    selectThis (item) {
      this.form.selected = [item]
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.calculateScores()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
        return true
      } else {
        return false
      }
    },
    calculateScores () {
      if (!this.data.fields.formula) {
        return
      }
      var options = []
      for (var i = 1; i <= 5; i++) {
        options.push(i)
      }
      this.$store.dispatch('CALCULATE_WEIGHTED_QUESTION', {
        formula: this.data.fields.formula,
        selected: this.form.selected,
        options: options,
        maxAnswers: 1
      }).then(scores => {
        this.form.weighted = scores.weighted.slice(0)
        this.form.weightedMin = scores.weightedMin
        this.form.weightedMax = scores.weightedMax
      }).catch(err => {
        console.log('err: ', err)
      })
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal)) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    },
    'rating': function (newVal, oldVal) {
      if (newVal) {
        this.selectThis(newVal)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .content {
    margin-bottom: 60px;
  }

  .grid-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    flex: 1;
  }

  .enlarge-icon {
    transform: scale(2.5);
    margin-right: -6px;
  }
  .optional-question-title {
    margin-top: 1em;
    padding: 0 1em;
  }
</style>
